export default __webpack_public_path__ + "static/media/peer_tutoring.b4bd2fc5.jpg";